<div class="page-header">
    <h2 id="commercialAutoHeader">
        COMMERCIAL AUTO INFORMATION</h2>
</div>
<div [formGroup]="commercialAutoForm">
    <div class="row form-group">
        <div class="col-sm-7 col-md-7 col-lg-5">
            <label for="vehicleYear">Year of vehicle</label>
            <input type="text" class="form-control" id="vehicleYear" name="vehicleYear" [formControl]="vehicleYear" aria-required="true" aria-describedby="vehicleYear"
                [ngClass]="{'has-error':(vehicleYear.touched && vehicleYear.invalid)}">
            <div *ngIf="vehicleYear.invalid && vehicleYear.touched" class="alert alert-danger nw-field-error" id="vehicleYearErrorId">
                <span *ngIf="vehicleYear.hasError('required')" id="vehicleYearErrorMessage">Required</span>
                <span *ngIf="vehicleYear.hasError('pattern')" id="vehicleYearErrorMessage">Year of vehicle is invalid</span>
            </div>
        </div>
    </div>
    <div class="row form-group">
        <div class="col-sm-7 col-md-7 col-lg-5">
            <label for="vehicleMake">Make</label>
            <input type="text" class="form-control" id="vehicleMake" name="vehicleMake" [formControl]="vehicleMake" aria-required="true" aria-describedby="vehicleMake"
                [ngClass]="{'has-error':(vehicleMake.touched && vehicleMake.invalid)}">
            <div *ngIf="vehicleMake.invalid && vehicleMake.touched" class="alert alert-danger nw-field-error" id="vehicleMakeErrorId">
                <span *ngIf="vehicleMake.hasError('required')" id="vehicleMakeErrorMessage">Required</span>
            </div>
        </div>
    </div>
    <div class="row form-group">
        <div class="col-sm-7 col-md-7 col-lg-5">
            <label for="vehicleModel">Model</label>
            <input type="text" class="form-control" id="vehicleModel" name="vehicleModel" [formControl]="vehicleModel" aria-required="true" aria-describedby="vehicleModel"
                [ngClass]="{'has-error':(vehicleModel.touched && vehicleModel.invalid)}">
            <div *ngIf="vehicleModel.invalid && vehicleModel.touched" class="alert alert-danger nw-field-error" id="vehicleModelErrorId">
                <span *ngIf="vehicleModel.hasError('required')" id="vehicleModelErrorMessage">Required</span>
            </div>
        </div>
    </div>
    <div class="row form-group">
        <div class="col-sm-7 col-md-7 col-lg-5">
            <span aria-required="true" class="control-label ng-not-empty" aria-hidden="false" aria-invalid="false">
                <label for="vehicleVIN" class="optional">VIN</label>
                <a id="tooltip_vehicleVIN" aria-label="tooltip vehicleVIN" role="button" class="nw-inline-help nw-icon-inline-help" [ngClass]="{'collapsed': !toolTipVars.vehicleVINHelptext1}"
                    (click)="toolTipVars.vehicleVINHelptext1 = !toolTipVars.vehicleVINHelptext1"></a>
            </span>
            <div class="nw-inline-help__content-container" [ngClass]="{'open': toolTipVars.vehicleVINHelptext1}" id="vehicleVIN_content">
                <div class="nw-inline-help__content">
                    The VIN is located on the driver's side interior dash or inside the driver's side door jamb.
                </div>
            </div>
            <input type="text" class="form-control" id="vehicleVIN" name="vehicleVIN" [formControl]="vehicleVIN" aria-required="true" aria-describedby="vehicleVIN">
        </div>
    </div>
    <div class="row form-group">
        <div class="col-sm-7 col-md-7 col-lg-5">
            <span aria-required="true" class="control-label ng-not-empty" aria-hidden="false" aria-invalid="false">
                <label for="primaryCause">Primary cause of the incident or damage</label>
                <a id="tooltip_primaryCause" aria-label="tooltip primaryCause" role="button" class="nw-inline-help nw-icon-inline-help" [ngClass]="{'collapsed': !toolTipVars.primaryCauseHelptext1}"
                    (click)="toolTipVars.primaryCauseHelptext1 = !toolTipVars.primaryCauseHelptext1"></a>
            </span>
            <div class="nw-inline-help__content-container" [ngClass]="{'open': toolTipVars.primaryCauseHelptext1}" id="primaryCause_content">
                <div class="nw-inline-help__content">
                    If you're unsure or more than one applies, select the primary cause that best describes the damage. This can be updated later
                    with a claims associate.
                </div>
            </div>
            <select class="form-control nw-input--medium" name="primaryCause" id="primaryCause" aria-required="true" aria-describedby="primaryCause" [formControl]="primaryCause"
                [ngClass]="{'has-error':(primaryCause.touched && primaryCause.invalid)}">
                <option value="" selected>Select</option>
                <option *ngFor="let primaryCause of primaryCauses">{{primaryCause}}</option>
            </select>
            <div *ngIf="primaryCause.touched && primaryCause.invalid" class="alert alert-danger nw-field-error" id="primaryCauseErrorId">
                <span id="primaryCauseErrorMessage">Required</span>
            </div>
        </div>
    </div>
    <div class="row form-group">
        <div class="col-sm-7 col-md-7 col-lg-5">
            <label for="insuredDriver">Name of insured driver</label>
            <input type="text" class="form-control" id="insuredDriver" name="insuredDriver" [formControl]="insuredDriver" aria-required="true" aria-describedby="insuredDriver"
                [ngClass]="{'has-error':(insuredDriver.touched && insuredDriver.invalid)}">
            <div *ngIf="insuredDriver.invalid && insuredDriver.touched" class="alert alert-danger nw-field-error" id="insuredDriverErrorId">
                <span *ngIf="insuredDriver.hasError('required')" id="insuredDriverErrorMessage">Required</span>
                <span *ngIf="insuredDriver.hasError('pattern')" id="insuredDriverErrorMessage">Insured driver name is invalid</span>
            </div>
        </div>
    </div>
    <div id="vehicleDrivableSection" class="row form-group">
        <div class="col-sm-7 col-md-7 col-lg-5">
            <fieldset>
                <legend for="vehicleDrivableAnswers">Is the vehicle drivable?</legend>
                <div class="btn-group" data-toggle="buttons" id="vehicleDrivableAnswers">
                    <label class="btn btn-default form-check-label" [ngClass]="{'active':(vehicleDrivableAnswer.value ==='Yes')}">
                        <input name="vehicleDrivableAnswer" class="form-check-input" type="radio" checked="vehicleDrivableAnswer.value ==='Yes'" autocomplete="off" value="Yes"
                            [formControl]="vehicleDrivableAnswer">Yes
                    </label>
                    <label class="btn btn-default form-check-label" [ngClass]="{'active':(vehicleDrivableAnswer.value ==='No')}">
                        <input name="vehicleDrivableAnswer" class="form-check-input" type="radio" checked="vehicleDrivableAnswer.value ==='No'" autocomplete="off" value="No"
                            [formControl]="vehicleDrivableAnswer">No
                    </label>
                    <label class="btn btn-default form-check-label" [ngClass]="{'active':(vehicleDrivableAnswer.value ==='unknown')}">
                        <input name="vehicleDrivableAnswer" class="form-check-input" type="radio" checked="vehicleDrivableAnswer.value ==='unknown'" autocomplete="off" value="unknown"
                            [formControl]="vehicleDrivableAnswer">I don't know
                    </label>
                </div>
                <div *ngIf="vehicleDrivableAnswer.invalid && vehicleDrivableAnswer.touched" class="alert alert-danger nw-field-error" id="vehicleDrivableAnswerErrorId">
                    <span *ngIf="vehicleDrivableAnswer.hasError('required')" id="vehicleDrivableAnswerErrorMessage">Required</span>
                </div>
            </fieldset>
        </div>
    </div>
    <div id="airBagsSection" class="row form-group">
        <div class="col-sm-7 col-md-7 col-lg-5">
            <fieldset>
                <legend for="airBagsDeployedAnswers">Were airbags deployed?</legend>
                <div class="btn-group" data-toggle="buttons" id="airBagsDeployedAnswers">
                    <label class="btn btn-default form-check-label" [ngClass]="{'active':(airBagsDeployedAnswer.value ==='Yes')}">
                        <input name="airBagsDeployedAnswer" class="form-check-input" type="radio" checked="airBagsDeployedAnswer.value ==='Yes'" autocomplete="off" value="Yes"
                            [formControl]="airBagsDeployedAnswer">Yes
                    </label>
                    <label class="btn btn-default form-check-label" [ngClass]="{'active':(airBagsDeployedAnswer.value ==='No')}">
                        <input name="airBagsDeployedAnswer" class="form-check-input" type="radio" checked="airBagsDeployedAnswer.value ==='No'" autocomplete="off" value="No"
                            [formControl]="airBagsDeployedAnswer">No
                    </label>
                    <label class="btn btn-default form-check-label" [ngClass]="{'active':(airBagsDeployedAnswer.value ==='unknown')}">
                        <input name="airBagsDeployedAnswer" class="form-check-input" type="radio" checked="airBagsDeployedAnswer.value ==='unknown'" autocomplete="off" value="unknown"
                            [formControl]="airBagsDeployedAnswer">I don't know
                    </label>
                </div>
                <div *ngIf="airBagsDeployedAnswer.invalid && airBagsDeployedAnswer.touched" class="alert alert-danger nw-field-error" id="airBagsDeployedAnswerErrorId">
                    <span *ngIf="airBagsDeployedAnswer.hasError('required')" id="airBagsDeployedAnswerErrorMessage">Required</span>
                </div>
            </fieldset>
        </div>
    </div>
    <div id="carSeatSection" class="row form-group" *ngIf="showCAQuestions() || showCOQuestions()">
        <div class="col-sm-7 col-md-7 col-lg-5">
            <fieldset>
                <legend for="carSeatAnswer">Was there a child passenger (including booster seat) restraint system in the vehicle at the time of the loss?</legend>
                <div class="btn-group" data-toggle="buttons" id="carSeatAnswer">
                    <label class="btn btn-default form-check-label" [ngClass]="{'active':(carSeatAnswer.value ==='Yes')}">
                        <input name="carSeatAnswer" class="form-check-input" type="radio" checked="carSeatAnswer.value ==='Yes'" autocomplete="off" value="Yes" [formControl]="carSeatAnswer"
                            (change)="updateCarSeatValidators()">Yes
                    </label>
                    <label class="btn btn-default form-check-label" [ngClass]="{'active':(carSeatAnswer.value ==='No')}">
                        <input name="carSeatAnswer" class="form-check-input" type="radio" checked="carSeatAnswer.value ==='No'" autocomplete="off" value="No" [formControl]="carSeatAnswer"
                            (change)="updateCarSeatValidators()">No
                    </label>
                    <label class="btn btn-default form-check-label" [ngClass]="{'active':(carSeatAnswer.value ==='unknown')}">
                        <input name="carSeatAnswer" class="form-check-input" type="radio" checked="carSeatAnswer.value ==='unknown'" autocomplete="off" value="unknown" [formControl]="carSeatAnswer"
                            (change)="updateCarSeatValidators()">I
                        don't know
                    </label>
                </div>
                <div *ngIf="carSeatAnswer.invalid && carSeatAnswer.touched" class="alert alert-danger nw-field-error" id="carSeatAnswerErrorId">
                    <span *ngIf="carSeatAnswer.hasError('required')" id="carSeatAnswerErrorMessage">Required</span>
                </div>
            </fieldset>
        </div>
    </div>
    <div id="carSeatUseSection" class="row form-group" *ngIf="showCAQuestions() && carSeatAnswer.value === 'Yes'">
        <div class="col-sm-7 col-md-7 col-lg-5">
            <fieldset>
                <legend for="carSeatUseAnswer">Was the car seat in use by a child at the time of the accident?</legend>
                <div class="btn-group" data-toggle="buttons" id="carSeatUseAnswer">
                    <label class="btn btn-default form-check-label" [ngClass]="{'active':(carSeatUseAnswer.value ==='Yes')}">
                        <input name="carSeatUseAnswer" class="form-check-input" type="radio" checked="carSeatUseAnswer.value ==='Yes'" autocomplete="off" value="Yes"
                            [formControl]="carSeatUseAnswer">Yes
                    </label>
                    <label class="btn btn-default form-check-label" [ngClass]="{'active':(carSeatUseAnswer.value ==='No')}">
                        <input name="carSeatUseAnswer" class="form-check-input" type="radio" checked="carSeatUseAnswer.value ==='No'" autocomplete="off" value="No" [formControl]="carSeatUseAnswer">No
                    </label>
                    <label class="btn btn-default form-check-label" [ngClass]="{'active':(carSeatUseAnswer.value ==='unknown')}">
                        <input name="carSeatUseAnswer" class="form-check-input" type="radio" checked="carSeatUseAnswer.value ==='unknown'" autocomplete="off" value="unknown"
                            [formControl]="carSeatUseAnswer">I don't know
                    </label>
                </div>
                <div *ngIf="carSeatUseAnswer.invalid && carSeatUseAnswer.touched" class="alert alert-danger nw-field-error" id="carSeatUseAnswerErrorId">
                    <span *ngIf="carSeatUseAnswer.hasError('required')" id="carSeatUseAnswerErrorMessage">Required</span>
                </div>
            </fieldset>
        </div>
    </div>
    <div id="carSeatDamageSection" class="row form-group" *ngIf="showCAQuestions() && carSeatAnswer.value === 'Yes'">
        <div class="col-sm-7 col-md-7 col-lg-5">
            <fieldset>
                <legend for="carSeatDamageAnswer">Was the car seat damaged in the accident?</legend>
                <div class="btn-group" data-toggle="buttons" id="carSeatDamageAnswer">
                    <label class="btn btn-default form-check-label" [ngClass]="{'active':(carSeatDamageAnswer.value ==='Yes')}">
                        <input name="carSeatDamageAnswer" class="form-check-input" type="radio" checked="carSeatDamageAnswer.value ==='Yes'" autocomplete="off" value="Yes"
                            [formControl]="carSeatDamageAnswer">Yes
                    </label>
                    <label class="btn btn-default form-check-label" [ngClass]="{'active':(carSeatDamageAnswer.value ==='No')}">
                        <input name="carSeatDamageAnswer" class="form-check-input" type="radio" checked="carSeatDamageAnswer.value ==='No'" autocomplete="off" value="No"
                            [formControl]="carSeatDamageAnswer">No
                    </label>
                    <label class="btn btn-default form-check-label" [ngClass]="{'active':(carSeatDamageAnswer.value ==='unknown')}">
                        <input name="carSeatDamageAnswer" class="form-check-input" type="radio" checked="carSeatDamageAnswer.value ==='unknown'" autocomplete="off" value="unknown"
                            [formControl]="carSeatDamageAnswer">I don't know
                    </label>
                </div>
                <div *ngIf="carSeatDamageAnswer.invalid && carSeatDamageAnswer.touched" class="alert alert-danger nw-field-error" id="carSeatDamageAnswerErrorId">
                    <span *ngIf="carSeatDamageAnswer.hasError('required')" id="carSeatDamageAnswerErrorMessage">Required</span>
                </div>
            </fieldset>
        </div>
    </div>
    <is-address [parentForm]="commercialAutoForm" [fieldNameSpace]="'vehicleLocation'" [addressHeader]="'Vehicle Location'"></is-address>
    <div class="row form-group">
        <div class="col-sm-7 col-md-7 col-lg-5">
            <label for="numberOfPassengers">Number of Passengers (excluding driver)</label>
            <input type="text" class="form-control" id="numberOfPassengers" name="numberOfPassengers" [formControl]="numberOfPassengers" aria-required="true" aria-describedby="numberOfPassengers"
                maxlength="2" size="2" style="width:50px;" [ngClass]="{'has-error':(numberOfPassengers.touched && numberOfPassengers.invalid)}">
            <div *ngIf="numberOfPassengers.invalid && numberOfPassengers.touched" class="alert alert-danger nw-field-error" id="numberOfPassengersErrorId">
                <span *ngIf="numberOfPassengers.hasError('required')" id="numberOfPassengersErrorMessage">Required</span>
                <span *ngIf="numberOfPassengers.hasError('pattern')" id="numberOfPassengersErrorMessage">Number of Passengers is invalid</span>
            </div>
        </div>
    </div>
    <div id="authoritesSection" class="row form-group">
        <div class="col-sm-7 col-md-7 col-lg-5">
            <fieldset>
                <legend for="authoritiesNotifiedAnswers">Have authorities been notified?</legend>
                <div class="btn-group" data-toggle="buttons" id="authoritiesNotifiedAnswers">
                    <label class="btn btn-default form-check-label" [ngClass]="{'active':(authoritiesNotifiedAnswer.value ==='Yes')}">
                        <input name="authoritiesNotifiedAnswer" class="form-check-input" type="radio" checked="authoritiesNotifiedAnswer.value ==='Yes'" autocomplete="off" value="Yes"
                            [formControl]="authoritiesNotifiedAnswer">Yes
                    </label>
                    <label class="btn btn-default form-check-label" [ngClass]="{'active':(authoritiesNotifiedAnswer.value ==='No')}">
                        <input name="authoritiesNotifiedAnswer" class="form-check-input" type="radio" checked="authoritiesNotifiedAnswer.value ==='No'" autocomplete="off" value="No"
                            [formControl]="authoritiesNotifiedAnswer">No
                    </label>
                    <label class="btn btn-default form-check-label" [ngClass]="{'active':(authoritiesNotifiedAnswer.value ==='unknown')}">
                        <input name="authoritiesNotifiedAnswer" class="form-check-input" type="radio" checked="authoritiesNotifiedAnswer.value ==='unknown'" autocomplete="off" value="unknown"
                            [formControl]="authoritiesNotifiedAnswer">I don't know
                    </label>
                </div>
                <div *ngIf="authoritiesNotifiedAnswer.invalid && authoritiesNotifiedAnswer.touched" class="alert alert-danger nw-field-error" id="authoritiesNotifiedAnswerErrorId">
                    <span *ngIf="authoritiesNotifiedAnswer.hasError('required')" id="authoritiesNotifiedAnswerErrorMessage">Required</span>
                </div>
            </fieldset>
        </div>
    </div>
</div>